module.exports = __webpack_public_path__ + "static/media/8.61cd7626.jpg";